/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechCamVideoIcon24Solid = forwardRef('TechCamVideoIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M5.5 4A4.5 4.5 0 0 0 1 8.5v7A4.5 4.5 0 0 0 5.5 20h8a4.5 4.5 0 0 0 4.5-4.5v-.286l3.628 2.592c.993.709 2.372 0 2.372-1.22V7.414c0-1.22-1.38-1.93-2.372-1.22L18 8.784V8.5A4.5 4.5 0 0 0 13.5 4h-8Z" })));
});
